import {
  GET_CATEGORIES_REQUEST1,
  GET_CATEGORIES_SUCCESS1,
  GET_CATEGORIES_ERROR1,
  GET_CATEGORIES_DONE1,
  GET_CATEGORY_VIDEOS_REQUEST1,
  GET_CATEGORY_VIDEOS_SUCCESS1,
  GET_CATEGORY_VIDEOS_ERROR1,
  PATIENT_REQUEST,
  PATIENT_SUCCESS,
  PATIENT_ERROR,
  GET_PLAYLIST_VIDEOS,
  GET_PLAYLIST_VIDEOS_ERROR,
  GET_PLAYLIST_VIDEOS_SUCCESS,
  GET_LNG_LAT_MAP_REQUEST,
  GET_LNG_LAT_MAP_ERROR,
  GET_LNG_LAT_MAP_SUCCESS,
  GET_QRCODEVISITE_REQUEST,
  GET_QRCODEVISITE_SUCCESS,
  GET_QRCODEVISITE_ERROR,
} from "./actions";

const initialState = {
  categoriesRequesting: false,
  categoriesSuccessful: false,
  categoryVideosRequesting: false,
  categoryVideosSuccessful: false,
  userinfoResquesting: false,
  userinfoSuccessful: false,
  userinfoError: false,
  // Mes modifs
  playlistVideoRequesting: false,
  playlistVideoError: false,
  playlistVideoSuccessful: false,
  // Get video
  playVideo: undefined,
  authData: undefined,
  // Get map
  mapLngLatRequesting: false,
  mapLngLatError: false,
  mapLngLatSuccess: false,
  lngLat: undefined,
  // stats
  statsRequesting: false,
  statsSuccessful: false,
  statsError: false,
  subdomain: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PATIENT_REQUEST:
      return {
        ...initialState,
        userinfoResquesting: true,
        userinfoSuccessful: false,
        userinfoError: false,
      };

    case PATIENT_SUCCESS:
      return {
        ...initialState,
        authData: action.authData,
        userinfoResquesting: false,
        userinfoSuccessful: true,
        userinfoError: false,
      };

    case GET_LNG_LAT_MAP_REQUEST:
      return {
        ...state,
        mapLngLatRequesting: true,
        mapLngLatError: false,
        mapLngLatSuccess: false,
        lngLat: action.lngLat,
      };

    case GET_LNG_LAT_MAP_ERROR:
      return {
        ...state,
        mapLngLatError: true,
        mapLngLatRequesting: false,
        mapLngLatSuccess: false,
        lngLat: undefined,
      };

    case GET_LNG_LAT_MAP_SUCCESS:
      return {
        ...state,
        mapLngLatError: undefined,
        mapLngLatRequesting: false,
        mapLngLatSuccess: true,
        lngLat: action.lngLat,
      };

    case GET_PLAYLIST_VIDEOS:
      return {
        ...state,
        playlistVideoRequesting: true,
        playlistVideoError: undefined,
        playVideo: action.playVideo,
        playlistVideoSuccessful: false,
      };

    case GET_PLAYLIST_VIDEOS_ERROR:
      return {
        ...state,
        playVideo: undefined,
        playlistVideoRequesting: false,
        playlistVideoError: true,
        playlistVideoSuccessful: false,
      };

    case GET_PLAYLIST_VIDEOS_SUCCESS:
      return {
        ...state,
        playVideo: action.playVideo,
        playlistVideoRequesting: false,
        playlistVideoError: undefined,
        playlistVideoSuccessful: true,
      };

    case PATIENT_ERROR:
      return {
        ...initialState,
        userinfoResquesting: false,
        userinfoSuccessful: false,
        userinfoError: true,
        authData: undefined,
      };
    case GET_CATEGORIES_REQUEST1:
      return {
        ...state,
        authData: action.authData,
        categoriesRequesting: true,
        categoriesSuccessful: false,
        categories: undefined,
        categoriesError: undefined,
      };

    case GET_CATEGORIES_SUCCESS1:
      return {
        ...state,
        categoriesRequesting: false,
        categoriesSuccessful: true,
        categories: action.categories,
        categoriesError: undefined,
      };

    case GET_CATEGORIES_ERROR1:
      return {
        ...state,
        categoriesRequesting: false,
        categoriesSuccessful: false,
        categories: undefined,
        categoriesError: action.error,
      };

    case GET_CATEGORIES_DONE1:
      return {
        ...initialState,
        userId: state.userId,
        categoriesSuccessful: state.categoriesSuccessful,
        categories: state.categories,
      };

    case GET_CATEGORY_VIDEOS_REQUEST1:
      return {
        ...state,
        categoryVideosRequesting: true,
        categoryVideosSuccessful: false,
        videos: undefined,
        categoryVideosError: undefined,
      };

    case GET_CATEGORY_VIDEOS_SUCCESS1:
      return {
        ...state,
        categoryVideosRequesting: false,
        categoryVideosSuccessful: true,
        videos: action.videos,
        categoryVideosError: undefined,
      };

    case GET_CATEGORY_VIDEOS_ERROR1:
      return {
        ...state,
        categoryVideosRequesting: false,
        categoryVideosSuccessful: false,
        videos: undefined,
        categoryVideosError: action.error,
      };

    case GET_QRCODEVISITE_REQUEST:
      // console.log("state QrcodeVisited", action)
      return {
        ...state,
        statsRequesting: true,
        statsSuccessful: false,
        subdomain: action,
        statsError: false,
      };

    case GET_QRCODEVISITE_SUCCESS:
      // console.log('Succes QrcodeVisited ', action.subdomain)
      return {
        ...state,
        statsRequesting: false,
        statsSuccessful: true,
        subdomain: action.subdomain,
        statsError: false,
      };

    case GET_QRCODEVISITE_ERROR:
      return {
        ...state,
        statsRequesting: false,
        statsSuccessful: false,
        subdomain: undefined,
        statsError: action.error,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/reducer.js